import { Routes, Route } from 'react-router';
import { Header } from './components/Header';
import { CartDrawer } from './components/CartDrawer';
import { Toaster } from './components/ui/sonner';
import { Home } from './routes/Home';
import { Category } from './routes/Category';
import { Product } from './routes/Product';
import { Search } from './routes/Search';
import { Cart } from './routes/Cart';
import { Login } from './routes/Login';
import { Checkout } from './routes/Checkout';
import { Orders } from './routes/Orders';
import { OrderDetail } from './routes/OrderDetail';
import { Instructor } from './routes/Instructor';

export function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main id="main" className="flex-1 mx-auto w-full max-w-6xl px-4 py-8">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/c/:category" element={<Category />} />
          <Route path="/p/:productId" element={<Product />} />
          <Route path="/search" element={<Search />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/login" element={<Login />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/orders/:orderId" element={<OrderDetail />} />
          <Route path="/instructor" element={<Instructor />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <CartDrawer />
      <Toaster />
      <footer className="border-t border-(--color-galleon-gold)/30 py-6 text-center text-sm text-(--color-ink-muted)">
        Diagon Alley · A teaching demo for OpenTelemetry · Not affiliated with Warner Bros.
      </footer>
    </div>
  );
}

function NotFound() {
  return (
    <div className="text-center py-16">
      <h1 className="font-display text-4xl mb-4">404 — Path not found</h1>
      <p className="text-(--color-ink-muted)">Even owls get lost sometimes.</p>
    </div>
  );
}
